/**
 * push_subscriptions — one row per browser that has opted in to web push.
 *
 * The row is written by the client the moment the browser hands over a
 * PushSubscription; the send-push edge function reads it (as service role)
 * to know where to deliver each notification.
 */

import supabase from "../config/supabase";

const pushSubscriptionsApi = {
  /**
   * Store or update this browser's subscription for the signed-in user.
   *
   * Upsert on `endpoint`: if the same phone signs in as somebody else and
   * subscribes, the endpoint stays unique and just moves to the new user.
   */
  async upsert({ endpoint, p256dh, auth, userAgent }) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return { success: false, error: "Not authenticated" };

    const { error } = await supabase
      .from("push_subscriptions")
      .upsert(
        {
          user_id: user.id,
          endpoint,
          p256dh,
          auth,
          user_agent: userAgent,
          last_used_at: new Date().toISOString(),
        },
        { onConflict: "endpoint" },
      );
    if (error) return { success: false, error: error.message };
    return { success: true };
  },

  async removeByEndpoint(endpoint) {
    if (!endpoint) return { success: true };
    const { error } = await supabase
      .from("push_subscriptions")
      .delete()
      .eq("endpoint", endpoint);
    if (error) return { success: false, error: error.message };
    return { success: true };
  },
};

export default pushSubscriptionsApi;
